<clr-tooltip>
    <clr-icon clrTooltipTrigger shape="help" size="14"></clr-icon>
    <clr-tooltip-content [clrPosition]="position" clrSize="md" *clrIfOpen>
        <span>{{ content }}</span>
    </clr-tooltip-content>
</clr-tooltip>
